import { TextColumns } from "@phosphor-icons/react";

import {
  DropdownMenu,
  DropdownMenuCheckbox,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuList,
  DropdownMenuTrigger,
} from "common/components/ui/DropdownMenu";
import FilterButton from "common/components/ui/FilterButton";

import type { Table as TableType } from "@tanstack/react-table";

interface ColumnsVisibilityFilterProps<TData> {
  table: TableType<TData>;
}

export default function ColumnsVisibilityFilter<TData>({
  table,
}: ColumnsVisibilityFilterProps<TData>) {
  const columnVisibility = table.getState().columnVisibility;

  const allColumns = table.getAllColumns();
  const hidableColumns = allColumns.filter((column) => column.getCanHide());

  function toggleColumnVisibility(columnId: string) {
    table.setColumnVisibility({
      ...columnVisibility,
      [columnId]: !columnVisibility[columnId],
    });
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <FilterButton leftIcon={<TextColumns />} size="sm" className="ml-auto">
          Display
        </FilterButton>
      </DropdownMenuTrigger>

      <DropdownMenuContent align="end" size="sm">
        <DropdownMenuList isScrollable={false}>
          {hidableColumns.map((column) => {
            const { header, meta, id } = column.columnDef;
            const isVisible = columnVisibility[id];
            const Icon = meta?.icon;

            return (
              <DropdownMenuItem
                key={column.id}
                className="group/checkbox"
                onSelect={(e) => {
                  e.preventDefault();
                  toggleColumnVisibility(id);
                }}
              >
                <DropdownMenuCheckbox
                  isChecked={isVisible}
                  onCheckedChange={() => toggleColumnVisibility(id)}
                />

                {Icon && <Icon weight="fill" />}
                {typeof header === "string" ? header : column.id}
              </DropdownMenuItem>
            );
          })}
        </DropdownMenuList>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
